import { render, staticRenderFns } from "./app.vue?vue&type=template&id=41ba2fda&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&lang=scss&global=true&"
import style1 from "./app.vue?vue&type=style&index=1&lang=scss&global=true&"
import style2 from "./app.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./app.vue?vue&type=style&index=3&lang=scss&"
import style4 from "./app.vue?vue&type=style&index=4&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QScrollObserver,QBtn,QField,QList,QItem,QTable,QRating,QDialog,QSpinner} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollObserver,QBtn,QField,QList,QItem,QTable,QRating,QDialog,QSpinner})
